<div class="container d-flex">
  <div class="left-checks col-3">
    <div
      *ngFor="let form of forms"
      class="form"
      [ngClass]="{ selected: selectedForms.includes(form) }"
      (click)="toggleFormSelection(form)"
    >
      <div class="completed" *ngIf="form.completed_at">
        <i class="bi bi-check-circle-fill me-2"></i>
        Completado
      </div>

      <div class="pending" *ngIf="!form.completed_at">
        <i class="bi bi-exclamation-circle-fill me-2"></i>
        Pendiente
      </div>
      <div class="d-flex">
        <div class="d-flex flex-column me-2">
          <span>{{ form.available_at | date : "dd/MM/yyyy" }}</span>
          <span class="fw-lighter" style="font-size: 12px">
            Fecha asignada</span
          >
        </div>

        <div class="d-flex flex-column" *ngIf="form.completed_at">
          <span> {{ form.completed_at | date : "dd/MM/yyyy" }}</span>
          <span class="fw-lighter" style="font-size: 12px">
            Fecha realizado
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="selectedForms.length === 2"
    class="comparison-container col-9 d-flex align-items-center flex-column"
  >
    <div class="d-flex justify-content-between col-6 my-4">
      <div class="d-flex flex-column me-2">
        <span> {{ selectedForms[0].completed_at | date : "dd/MM/yyyy" }}</span>
        <span class="fw-lighter" style="font-size: 12px"> Primer Chequeo</span>
      </div>

      <div class="d-flex flex-column">
        <span>{{ selectedForms[1].completed_at | date : "dd/MM/yyyy" }}</span>
        <span class="fw-lighter" style="font-size: 12px"> Segunda Chequeo</span>
      </div>
    </div>

    <div
      *ngFor="let response of longerForm.responses; let i = index"
      class="p-3 comparision-block col-10"
    >
      <div class="comparison-question">{{ response.question }}</div>

      <div
        class="comparison-answers"
        *ngIf="response.type == 'STRING' || response.type == 'NUMBER'"
      >
        <div
          [ngClass]="{
            'fs-3': response.type == 'NUMBER',
            'small-text': response.type == 'STRING'
          }"
          class="w-50 text-center"
          *ngIf="
            selectedForms[0].responses[i] &&
            selectedForms[0].responses[i].answer
          "
        >
          {{ selectedForms[0].responses[i].answer }}
        </div>

        <div
          [ngClass]="{
            'fs-3': response.type == 'NUMBER',
            'small-text': response.type == 'STRING'
          }"
          class="w-50 text-center"
          *ngIf="!selectedForms[0].responses[i]"
        >
          Sin respuesta
        </div>

        <div
          [ngClass]="{
            'fs-3': response.type == 'NUMBER',
            'small-text': response.type == 'STRING'
          }"
          class="w-50 text-center"
          *ngIf="selectedForms[1].responses[i]"
        >
          {{ selectedForms[1].responses[i].answer }}
        </div>

        <div
          [ngClass]="{
            'fs-3': response.type == 'NUMBER',
            'small-text': response.type == 'STRING'
          }"
          class="w-50 text-center"
          *ngIf="!selectedForms[1].responses[i]"
        >
          Sin respuesta
        </div>
      </div>

      <div class="comparison-answers" *ngIf="response.type == 'PHOTO'">
        <img [src]="selectedForms[0].responses[i].answer" class="w-50" alt="" />

        <img [src]="selectedForms[1].responses[i].answer" class="w-50" />
      </div>
    </div>
  </div>
</div>
